// app/javascript/controllers/testimonial_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card", "prevBtn", "nextBtn"];
  static values = {
    current: Number,
    autoplay: Boolean,
    interval: Number,
  };

  connect() {
    this.currentValue = 0;
    this.autoplayValue = this.autoplayValue ?? true;
    this.intervalValue = this.intervalValue ?? 5000;

    this.updateCards();
    this.startAutoplay();
  }

  disconnect() {
    this.stopAutoplay();
  }

  // Actions appelées depuis le HTML
  next() {
    this.currentValue = (this.currentValue + 1) % this.cardTargets.length;
    this.updateCards();
  }

  prev() {
    this.currentValue =
      (this.currentValue - 1 + this.cardTargets.length) %
      this.cardTargets.length;
    this.updateCards();
  }

  // Pause autoplay on hover
  pauseAutoplay() {
    this.stopAutoplay();
  }

  // Resume autoplay when mouse leaves
  resumeAutoplay() {
    if (this.autoplayValue) {
      this.startAutoplay();
    }
  }

  // Private methods
  updateCards() {
    this.cardTargets.forEach((card, index) => {
      //   card.classList.remove("active");

      if (index === this.currentValue) {
        // Active card
        this.setCardStyles(card, {
          transform: "translateY(60px) scale(1)",
          opacity: "1",
          zIndex: "3",
        });
      } else if (index === (this.currentValue + 1) % this.cardTargets.length) {
        // Second card
        this.setCardStyles(card, {
          transform: "translateY(30px) scale(0.95)",
          opacity: "0.7",
          zIndex: "2",
        });
      } else {
        // Third card and beyond
        this.setCardStyles(card, {
          transform: "translateY(0px) scale(0.9)",
          opacity: "0.4",
          zIndex: "1",
        });
      }
    });
  }

  setCardStyles(card, styles) {
    Object.assign(card.style, styles);
  }

  startAutoplay() {
    if (this.autoplayValue && !this.autoplayTimer) {
      this.autoplayTimer = setInterval(() => {
        this.next();
      }, this.intervalValue);
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  // Stimulus lifecycle - appelé quand les values changent
  currentValueChanged() {
    if (this.hasCardTarget) {
      this.updateCards();
    }
  }
}
